var React = require('react');

function Articles (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"fill-none stroke-foreground"},[React.createElement("line",{"x1":"3.3","y1":"6.5","x2":"15.4","y2":"6.6","key":0}),React.createElement("line",{"x1":"3.3","y1":"12.5","x2":"21.5","y2":"12.5","key":1}),React.createElement("line",{"x1":"3.3","y1":"18.5","x2":"12.4","y2":"18.5","key":2})]));
}

Articles.defaultProps = {"version":"1.1","width":"24px","height":"24px","viewBox":"0 0 24 24","style":{"enableBackground":"new 0 0 24 24"},"xmlSpace":"preserve"};

module.exports = Articles;

Articles.default = Articles;
